import { render, staticRenderFns } from "./advertContent.vue?vue&type=template&id=7f287bd1&scoped=true&"
import script from "./advertContent.vue?vue&type=script&lang=js&"
export * from "./advertContent.vue?vue&type=script&lang=js&"
import style0 from "./advertContent.vue?vue&type=style&index=0&id=7f287bd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f287bd1",
  null
  
)

export default component.exports